import {IN_APP_SEARCH_QUERY_PARAM_KEY, IN_APP_SEARCH_QUERY_PARAM_VALUE} from '@/lib/in-app/config'

export default function shouldSetIsInApp() {
  const params = new URLSearchParams(window.location.search)
  return params.get(IN_APP_SEARCH_QUERY_PARAM_KEY) === IN_APP_SEARCH_QUERY_PARAM_VALUE
}
